import ErrorPage from './default';
import { INCOMPATIBLE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT } from './constants';

function IncompatibleAdditionalFiberErrorPage(props) {
  return (
    <ErrorPage
      {...props}
      title={INCOMPATIBLE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT.TITLE}
      description={INCOMPATIBLE_ADDITIONAL_FIBER_ERROR_PAGE_TEXT.DESCRIPTION}
      iconColor="BLUE"
      iconId="informacion"
      showLink={false}
    />
  );
}
export default IncompatibleAdditionalFiberErrorPage;
